import {Observable} from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {ConfService} from "../conf.service";
import {environment} from '../../environments/environment';


export interface FooInterface {
    status: string;
    fooString: string;
    fooNumber: number;
    id: string;
    sid: string;
}

@Injectable()
export class Loggedin {
    constructor(private _http: HttpClient, public router: Router
    ) {
    }

    public getLogin(): boolean {
        return true;
    }

    public logout() {
        // remove user from local storage to log user out
        // Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'logout_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
        //     const payloadToSend = {
        //         actions: response
        //     };
        //     this.logoutListenerInstance.logoutListener.emit({
        //         type: 'audit',
        //         id: localStorage.getItem('IdOfSession'),
        //         payload: payloadToSend
        //     });
        // });
        localStorage.removeItem('partner');
        localStorage.removeItem('partnerId');
        localStorage.removeItem('Auth');
        localStorage.removeItem('partnerKey');
        localStorage.removeItem('currentPlan');
        localStorage.removeItem('account');
        localStorage.removeItem('domainPartner');
        localStorage.removeItem('sessionID');
        localStorage.removeItem('sessionStartTime');
        localStorage.removeItem('IdOfSession');
        localStorage.removeItem('signInEmail');
        localStorage.removeItem('apikey');
        localStorage.removeItem('logo');
        localStorage.removeItem('brandImage');
        localStorage.removeItem('availableEnvironmentsToSwitch');

        localStorage.removeItem('updatedBusLogAPI');
        localStorage.removeItem('workFlowAPI');
        localStorage.removeItem('b2bAPI');
        localStorage.removeItem('dmnAPI');
        localStorage.removeItem('sqlQueryAPI');
        localStorage.removeItem('thirdPartyAPI');
        localStorage.removeItem('businessLogicAPI');
        localStorage.removeItem('testSuiteAPI');
        localStorage.removeItem('isBusLogAPISet');
        localStorage.removeItem('dataAccessAPI');
        localStorage.removeItem('currentPlanDisplayName');
        localStorage.removeItem('selectDB');

        // Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'logout_success', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
        //     const payloadToSend = {
        //         actions: response
        //     };
        //     this.logoutListenerInstance.logoutListener.emit({
        //         type: 'audit',
        //         id: localStorage.getItem('IdOfSession'),
        //         payload: payloadToSend
        //     });
        // });
        // this.router.navigate(['/home']);


        // Included the below snippet under timeout to ensure that logging out is done seamlessly if multiple tabs are opened
        setTimeout(() => {
            if (localStorage.getItem('setLogOutFromAllTabs')) {
                localStorage.removeItem('setLogOutFromAllTabs');
            }
            window.location.href = environment.staticSite;
        }, 1000);
    }

    public logoutWithoutReload() {
        localStorage.removeItem('partner');
        localStorage.removeItem('partnerId');
        localStorage.removeItem('Auth');
        localStorage.removeItem('partnerKey');
        localStorage.removeItem('currentPlan');
        localStorage.removeItem('account');
        localStorage.removeItem('domainPartner');
        localStorage.removeItem('sessionID');
        localStorage.removeItem('IdOfSession');
        localStorage.removeItem('signInEmail');
        localStorage.removeItem('apikey');
        localStorage.removeItem('logo');
        localStorage.removeItem('brandImage');
        localStorage.removeItem('JWTToken');
        localStorage.removeItem('availableEnvironmentsToSwitch');
        localStorage.removeItem('currentPlanDisplayName');
        localStorage.removeItem('selectDB');
    }

    public clearLocalStorage() {
        localStorage.removeItem('partner');
        localStorage.removeItem('partnerId');
        localStorage.removeItem('Auth');
        localStorage.removeItem('partnerKey');
        localStorage.removeItem('currentPlan');
        localStorage.removeItem('account');
        localStorage.removeItem('signInEmail');
        localStorage.removeItem('JWTToken');
        localStorage.removeItem('availableEnvironmentsToSwitch');
        localStorage.removeItem('currentPlanDisplayName');
        localStorage.removeItem('selectDB');
        // localStorage.removeItem('domainPartner');
        // localStorage.removeItem('sessionID');
        // localStorage.removeItem('IdOfSession');
        // localStorage.removeItem('signInEmail');
        localStorage.removeItem('apikey');
        // localStorage.removeItem('logo');
        // localStorage.removeItem('brandImage');
    }
}


@Injectable()
export class PlatformCentralAuth implements CanActivate {
    constructor(
        private login: Loggedin, public router: Router,
        private configService: ConfService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
         /*if (localStorage.getItem('Token')) {
             const token = {
                 "token": localStorage.getItem('Token')
             };
             return this.configService.validateAuth(token).pipe(map((auth) => {
                 if (auth) {
                     return true;
                 } else {
                     return false;
                 }
             })).catch((error: any) => {
                 if (error.status === 500) {
                     this.router.navigate(['/login'], { queryParams: { return: state.url }} ) ;
                     return Observable.throw(new Error(error.status));
                 }});
         } else {
             this.router.navigate(['/login'], { queryParams: { return: state.url }} ) ;
             return false; }*/
        if (localStorage.getItem('Auth')) {
            return true;
        } else {
            this.router.navigate(['/auth/login'], {queryParams: {return: state.url}});
            return false;
        }
        // return true;
    }
}

